import { configureStore } from "@reduxjs/toolkit";
import documentsSlice  from "./slices/documentsSlice";

export default configureStore({
  reducer: {
    documents: documentsSlice,
  }
})